import { render, staticRenderFns } from "./AmetrasPdfFieldTemplate.vue?vue&type=template&id=ec4d185a&scoped=true&"
import script from "./AmetrasPdfFieldTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasPdfFieldTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasPdfFieldTemplate.vue?vue&type=style&index=0&id=ec4d185a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4d185a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VProgressLinear})
